import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { searchMusicBrainz, importMusicaFromMusicbrainz } from '../services/api';
import { useMediaQuery } from 'react-responsive';

function MusicaImportMusicBrainz() {
  const [artist, setArtist] = useState('');
  const [title, setTitle] = useState('');
  const [ean, setEan] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [importing, setImporting] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  
  const isMobile = useMediaQuery({ maxWidth: 991 });

  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSearchResults([]);
    setSuccessMessage(null);

    if (!ean && !artist && !title) {
      setError('Fornire almeno un campo per la ricerca (EAN, Artista o Titolo).');
      setLoading(false);
      return;
    }

    try {
      const response = await searchMusicBrainz({ ean, artist, title });
      setSearchResults(response.data);
    } catch (err) {
      setError(`Errore durante la ricerca su MusicBrainz: ${err.response?.data?.detail || err.message}`);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleImport = async (musicbrainzId) => {
    setImporting(musicbrainzId);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await importMusicaFromMusicbrainz(musicbrainzId);
      const newMusicaId = response.data.id;
      setSuccessMessage('Album importato con successo!');
      setSearchResults(prevResults => prevResults.filter(item => item.id !== musicbrainzId));
      navigate(`/musica/edit/${newMusicaId}`);
    } catch (err) {
      setError(`Errore durante l'importazione dell'album: ${err.response?.data?.detail || err.message}`);
      console.error(err);
    } finally {
      setImporting(null);
    }
  };

  return (
    <Container>
      <Row className="mb-4 align-items-center">
        <Col>
          <h1>Importa Musica da MusicBrainz</h1>
        </Col>
        <Col xs="auto">
          <Button variant="secondary" onClick={() => navigate('/musica')}>
            Torna alla Lista Musica
          </Button>
        </Col>
      </Row>
      <Form onSubmit={handleSearch} className="mb-4">
        <Row className="align-items-end">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Artista</Form.Label>
              <Form.Control
                type="text"
                placeholder="Es. Nirvana"
                value={artist}
                onChange={(e) => setArtist(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group>
              <Form.Label>Titolo Album</Form.Label>
              <Form.Control
                type="text"
                placeholder="Es. Nevermind"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>EAN (Barcode)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Es. 0720642442527"
                value={ean}
                onChange={(e) => setEan(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={2} className="d-flex align-items-end">
            <Button variant="primary" type="submit" disabled={loading} className="w-100">
              {loading ? <Spinner animation="border" size="sm" /> : 'Cerca'}
            </Button>
          </Col>
        </Row>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

      <Row>
        {searchResults.map((item) => (
          <Col md={4} className="mb-4" key={item.id}>
            <Card>
              <Card.Img variant="top" src={`https://via.placeholder.com/300x300.png?text=${item.title}`} alt={item.title} style={{ height: '300px', objectFit: 'cover' }} />
              <Card.Body>
                <Card.Title>{item.title} ({item.date ? item.date.split('-')[0] : 'N/A'})</Card.Title>
                <Card.Text><strong>Artista:</strong> {item.artist}</Card.Text>
                {item.supporto && <Card.Text><strong>Supporto:</strong> {item.supporto}</Card.Text>}
                {item.ean && <Card.Text><strong>EAN:</strong> {item.ean}</Card.Text>}
                {item.country && <Card.Text><strong>Paese:</strong> {item.country}</Card.Text>}
                <Button 
                  variant="success" 
                  onClick={() => handleImport(item.id)} 
                  disabled={importing === item.id}
                  className="mt-2"
                >
                  {importing === item.id ? <Spinner animation="border" size="sm" /> : 'Importa'}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default MusicaImportMusicBrainz;
